import { Interweave } from "interweave";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL, GET_CONTENTS_BY_MENU_ID, GET_IMAGE_BY_MENU_ID } from "../../constant/constants";
import shape from "../../images/ab-shape-2.png";

function items ( obj )
{
  let content = [];

  // eslint-disable-next-line no-unused-vars
  for ( let key in obj )
  {
    let contentItem = {};
    let objs = obj;

    contentItem[ `${ key }` ] = objs[ key ];
    content.push( contentItem );
  }
  return content;
}

const AboutS2 = ( props ) =>
{
  console.log( `props`, props );
  // const { id } = useParams();
  console.log( "aboutID", props.id );
  const [ contents, setContents ] = useState( "" );
  const [ contentsImage, setContentsImage ] = useState( "" );
  console.log( `contentsImage`, contentsImage );
  const dispatch = useDispatch();
  const images = useSelector( ( state ) => state.data.images );
  //for content images

  useEffect( () =>
  {

    fetch( `${ GET_IMAGE_BY_MENU_ID }/${ props.id }` )
      .then( ( res ) => res.json() )
      .then( ( data ) => setContentsImage( data.content_images ) );

    // dispatch(getAllimages(props.id));
    // setContentsImage(images);

    fetch( `${ GET_CONTENTS_BY_MENU_ID }/${ props.id }` )
      .then( ( res ) => res.json() )
      .then( ( data ) => setContents( data.menu_contents ) );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ props.id ] );

  const newContents = items( contents );
  console.log( "content", newContents );

  return (
    <section className="wpo-about-section section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-wrap">
              { Object.entries( contentsImage ? contentsImage : {} ).map(
                ( [ key, value ] ) =>
                  key === "About" ? (
                    <div className="wpo-about-img">
                      <img
                        style={ { height: "700px" } }
                        src={ `${ BASE_URL }/media/${ value }` }
                        alt=""
                      />
                      <div className="wpo-ab-shape-1">
                        <div className="s-s1"></div>
                        <div className="s-s2"></div>
                      </div>
                      <div className="wpo-ab-shape-2">
                        <img src={ shape } alt="" />
                      </div>
                    </div>
                  ) : (
                    " "
                  )
              ) }
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <div className="wpo-about-text px-2">
              {
                newContents
                  .filter( content => content[ "0" ] && content[ "0" ].name === 'About' ) // Filter by the name "About"
                  .map( ( content, index ) => (
                    <div className="text-justify" key={ index }>
                      <Interweave
                        allowAttributes
                        allowElements
                        disableLineBreaks={ true }
                        content={ content[ "0" ].value } // Access the "value" field inside the nested object
                      />
                    </div>
                  ) )
              }
            </div>

          </div>
        </div>
      </div>
    </section >
  );
};

export default AboutS2;
